module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "geos-casa-gfed-cover.85410fe9.jpg";